import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ENV } from 'config/env';
import { AuthProvider, msalConfig } from 'features/auth';
import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { api } from 'shared/api';
import { BrowserDetector } from 'shared/components';
import { MuiLocalizationProvider } from 'shared/contexts';
import { queryClient } from 'shared/query';
import { muiTheme } from 'shared/theme/mui';
import { ThemeProvider } from 'styled-components';

import store from './store';
import { theme } from './theme';

const pca = new PublicClientApplication(msalConfig);
pca.initialize().then(() => {
    api.initializeInterceptors(pca);
});

export default function CommonProviders({ children }: PropsWithChildren<unknown>) {
    return (
        <QueryClientProvider client={ queryClient }>
            <MuiThemeProvider theme={ muiTheme }>
                <ThemeProvider theme={ theme }>
                    <CssBaseline />
                    <BrowserDetector />
                    <Provider store={ store }>
                        <MsalProvider instance={ pca }>
                            <AuthProvider>
                                <MuiLocalizationProvider>
                                    { children }
                                </MuiLocalizationProvider>
                            </AuthProvider>
                        </MsalProvider>
                    </Provider>
                </ThemeProvider>
            </MuiThemeProvider>

            { ENV.NODE_ENV === 'development' && (
                <ReactQueryDevtools initialIsOpen={ false } />
            ) }
        </QueryClientProvider>
    );
}
